import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Button, Flexer } from '@ontruck/orc';
import config from 'config';
import Searcher from 'modules/searcher';
import AvailableToggle from 'modules/agent-availability/available-toggle';
import { UpgradeAlertComponent } from 'modules/versioning';
import { injectIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { getSpecificClientConfig, constants } from 'redux/modules/client-config/selectors';
import { logout } from 'actions/auth';
import { connect } from 'react-redux';
import styled from 'styled-components';

const ButtonWithIconText = Button;
ButtonWithIconText.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

const ButtonStyled = styled(ButtonWithIconText)`
  :hover {
    svg path {
      fill: var(--primary-top-bar-submenu-icon-hover);
    }

    background-color: transparent;
  }

  svg {
    margin: 0;

    path {
      fill: var(--primary-top-bar-submenu-icon);
    }
  }

  border: none;
`;

const Submenu = ({ toggleModal, onChangeSection, intl, logout }) => {
  const searcher = useSelector((state) =>
    getSpecificClientConfig(state, constants.HEADER_SEARCH_BAR)
  );
  const availableUser = useSelector((state) =>
    getSpecificClientConfig(state, constants.USER_AVAILABILITY)
  );
  const settings = useSelector((state) => getSpecificClientConfig(state, constants.SETTINGS_TAB));
  const newShipperOrder = useSelector((state) =>
    getSpecificClientConfig(state, constants.NEW_SHIPPER_ORDER)
  );
  const settingsPath = `${config.BASE_ROUTE}settings`;
  const newPath = `${config.BASE_ROUTE}new_shipper_order`;

  const onSettingsClick = useCallback(() => {
    onChangeSection(settingsPath);
  }, [onChangeSection, settingsPath]);

  const onNewClick = useCallback(() => {
    onChangeSection(newPath);
    toggleModal(true);
  }, [onChangeSection, toggleModal, newPath]);
  const t = intl.messages.modules.TopBar;
  return (
    <Flexer.Parent className="submenu">
      <UpgradeAlertComponent />
      {settings && (
        <Flexer.Child mRight="S">
          <Button ghost skin="primary" icon="cog" iconPosition="left" onClick={onSettingsClick} />
        </Flexer.Child>
      )}
      {newShipperOrder && (
        <Flexer.Child mRight="S">
          <Button ghost skin="primary" text={t.new} onClick={onNewClick} />
        </Flexer.Child>
      )}
      {availableUser && (
        <Flexer.Child mRight="S">
          <AvailableToggle />
        </Flexer.Child>
      )}
      {searcher && (
        <Flexer.Child mRight="S">
          <Searcher />
        </Flexer.Child>
      )}
      <Flexer.Child mRight="S">
        <ButtonStyled
          ghost
          skin="primary"
          text={
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_1156_3519)">
                <path
                  d="M13.5 17.5C13.2348 17.5 12.9804 17.6054 12.7929 17.7929C12.6054 17.9804 12.5 18.2348 12.5 18.5V21C12.5 21.1326 12.4473 21.2598 12.3536 21.3536C12.2598 21.4473 12.1326 21.5 12 21.5H2.5C2.36739 21.5 2.24021 21.4473 2.14645 21.3536C2.05268 21.2598 2 21.1326 2 21V3C2 2.86739 2.05268 2.74021 2.14645 2.64645C2.24021 2.55268 2.36739 2.5 2.5 2.5H12C12.1326 2.5 12.2598 2.55268 12.3536 2.64645C12.4473 2.74021 12.5 2.86739 12.5 3V5.5C12.5 5.76522 12.6054 6.01957 12.7929 6.20711C12.9804 6.39464 13.2348 6.5 13.5 6.5C13.7652 6.5 14.0196 6.39464 14.2071 6.20711C14.3946 6.01957 14.5 5.76522 14.5 5.5V2.5C14.5 1.96957 14.2893 1.46086 13.9142 1.08579C13.5391 0.710714 13.0304 0.5 12.5 0.5H2C1.46957 0.5 0.960859 0.710714 0.585786 1.08579C0.210714 1.46086 0 1.96957 0 2.5L0 21.5C0 22.0304 0.210714 22.5391 0.585786 22.9142C0.960859 23.2893 1.46957 23.5 2 23.5H12.5C13.0304 23.5 13.5391 23.2893 13.9142 22.9142C14.2893 22.5391 14.5 22.0304 14.5 21.5V18.5C14.5 18.2348 14.3946 17.9804 14.2071 17.7929C14.0196 17.6054 13.7652 17.5 13.5 17.5Z"
                  fill="#94A6B8"
                />
                <path
                  d="M23.555 11.669L17.555 7.669C17.4045 7.56857 17.2295 7.51087 17.0488 7.50204C16.868 7.49322 16.6883 7.5336 16.5287 7.61889C16.3691 7.70418 16.2356 7.83118 16.1425 7.98635C16.0494 8.14152 16.0002 8.31905 16 8.5V11H7C6.80302 11 6.60796 11.0388 6.42597 11.1142C6.24399 11.1896 6.07863 11.3001 5.93934 11.4393C5.80005 11.5786 5.68956 11.744 5.61418 11.926C5.5388 12.108 5.5 12.303 5.5 12.5C5.5 12.697 5.5388 12.892 5.61418 13.074C5.68956 13.256 5.80005 13.4214 5.93934 13.5607C6.07863 13.7 6.24399 13.8104 6.42597 13.8858C6.60796 13.9612 6.80302 14 7 14H16V16.5C16.0036 16.7641 16.1101 17.0163 16.2969 17.2031C16.4837 17.3899 16.7359 17.4964 17 17.5C17.1975 17.5 17.3907 17.4416 17.555 17.332L23.555 13.332C23.692 13.2407 23.8043 13.117 23.8819 12.9718C23.9596 12.8267 24.0002 12.6646 24.0002 12.5C24.0002 12.3354 23.9596 12.1733 23.8819 12.0282C23.8043 11.883 23.692 11.7603 23.555 11.669Z"
                  fill="#94A6B8"
                />
              </g>
              <defs>
                <clipPath id="clip0_1156_3519">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
          }
          iconPosition="left"
          onClick={logout}
        />
      </Flexer.Child>
    </Flexer.Parent>
  );
};

export default injectIntl(
  connect(
    (state) => ({
      user: state.me,
    }),
    { logout }
  )(Submenu)
);
